import { Type } from "@shared/ui/Type";
import MarketingContactForm from "./MarketingContactForm";

export function MarketingContact() {
  return (
    <div className="flex flex-col gap-12">
      <Type variant="body1">
        Have a question or idea for us? We'd love to hear from you. Use the
        below form to drop us a line, and we'll get back to you within five
        business days.
      </Type>
      <MarketingContactForm />
    </div>
  );
}

export default MarketingContact;
